import {AfterViewInit, Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PointsListComponent} from './point-list/point-list.component';
import {PaymentInfoComponent} from './payment-info/payment-info.component';

@Component({
  selector: 'app-points-purchase',
  templateUrl: 'points-purchase.component.html',
  styleUrls: ['points-purchase.component.scss'],
  imports: [CommonModule, PointsListComponent, PaymentInfoComponent]
})
export class PointsPurchaseComponent implements AfterViewInit {
  ngAfterViewInit() {
    // Используем setTimeout, чтобы дождаться завершения рендеринга
    setTimeout(() => {
      document.getElementById('top')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  }
}
